import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import { Button, Form, Input } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from '../messages';

class ForgetPassword extends React.Component {
  state = {
    loading: false,
    email: '',
    message: '',
  };

  _confirm = async () => {
    this.setState({ loading: true });
    await this.props.resetUserPassword({
      variables: {
        email: this.state.email,
      },
    });
    this.setState({
      loading: false,
      message: this.props.intl.formatMessage({ ...messages.resetPassMessage }),
    });
    // this.props.setMessage("Steps to reset your password will be sent to your email")
    // this.props.onClose()
  };

  render() {
    if (this.props.visible === false) {
      return null;
    }

    return (
      <Form loading={this.state.loading}>
        <Form.Field>
          <label htmlFor="presentation">
            <FormattedMessage {...messages.email} />
          </label>
          <Input
            type="email"
            placeholder="example@email.com"
            value={this.state.email}
            onChange={(e) => this.setState({ email: e.target.value })}
          />
          <small className="successMessage">{this.state.message}</small>
        </Form.Field>

        <Form.Field>
          <Button as="a" fluid color="black" onClick={() => this._confirm()}>
            <FormattedMessage {...messages.resetPassword} />
          </Button>
        </Form.Field>

        <Form.Field>
          <Button
            as="a"
            basic
            fluid
            onClick={(e) => this.props.goTo('login', e)}
          >
            <FormattedMessage {...messages.backToLogin} />
          </Button>
        </Form.Field>
      </Form>
    );
  }
}

const PASSWORD_RESET_MUTATION = gql`
  mutation resetUserPassword($email: String!) {
    resetPassword(email: $email) {
      id
    }
  }
`;

export default compose(
  injectIntl,
  withRouter,
  graphql(PASSWORD_RESET_MUTATION, { name: 'resetUserPassword' })
)(ForgetPassword);



// WEBPACK FOOTER //
// ./app/containers/Auth/ForgetPassword/index.js